(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('userRemoveAction', {
      controller: Controller,
      templateUrl: 'actions/user/remove/remove-user.action.html',
      bindings: {
        userId: '<',
        teamId: '<',
        then: '&',
        catch: '&'
      }
    });
}());
